<td *ngIf="noData"></td>
<ng-container *ngFor="let total of totalrow">
    <td *ngIf="indexCons.show" [ngClass]="total[0]?.class || 'total-row'">-</td>
    <ng-container *ngFor="let totalData of total; let i=index">
        <ng-container *ngIf="customTemplates && customTemplates[i]">
            <ng-container *ngTemplateOutlet="customTemplates[i];context:{rowData: total, index:i}">
            </ng-container>
        </ng-container>
        <ng-container *ngIf="!customTemplates || !customTemplates[i]">
            <td [ngClass]="totalData?.class || 'total-row'" lib-table-cell [cellData]="totalData" [isTotalData]="true">
            </td>
        </ng-container>
    </ng-container>
</ng-container>